/* istanbul ignore file */
import React, { ComponentType, ReactNode } from 'react';
import { useTestAB } from '@catalogo/core-experiments';

interface WithPaymentExperimentProps {
  children: ReactNode;
}

export const withPaymentExperiment = (Component: ComponentType) => (props: WithPaymentExperimentProps) => {
  const paymentExperiment = useTestAB('CAT_028_PAYMENT');
  const componentProps = {
    ...props,
    experiment: paymentExperiment,
  };

  return <Component {...componentProps} />;
};

export default withPaymentExperiment;
